import { Button, SxProps, Theme } from "@mui/material";
import SaveSpinner from "components/SaveSpinner";
import theme from "theme";

export interface PinToProfileButtonProps {
  formMode: boolean;
  canSave: boolean;
  isSaving: boolean;
  toggleFormMode: () => unknown;
  pendo?: string;
  sx?: SxProps<Theme>;
}

const PinToProfileButton = (props: PinToProfileButtonProps) => {
  const { formMode, canSave, isSaving, toggleFormMode, pendo, sx } = props;

  return (
    <Button
      data-pendo={pendo}
      id="hit_card_pin_to_profile"
      size="small"
      variant="contained"
      sx={{
        ...sx,
        marginLeft: theme.spacing(1),
      }}
      color="primary"
      disabled={formMode ? !canSave : false}
      onClick={toggleFormMode}>
      {formMode ? (isSaving ? "Saving" : "Save") : `Pin to Profile`}
      {isSaving && <SaveSpinner style={{ marginLeft: 4 }} state="saving" />}
    </Button>
  );
};

export default PinToProfileButton;
